import { jsx as _jsx } from "react/jsx-runtime";
import Ttip from '@/components/base/Tooltip';
import styled from 'styled-components';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var TooltipStyled = styled.div.withConfig({
    displayName: "ToolTip__TooltipStyled",
    componentId: "sc-45w5hk-0"
})([
    "&.header-tooltip{",
    "}",
    " box-shadow:0px 3px 14px 2px rgba(0,0,0,0.05),0px 8px 10px 1px rgba(0,0,0,0.06),0px 5px 5px -3px rgba(0,0,0,0.1);.item{",
    " &.active,&:hover{",
    "}}"
], {
    "marginTop": "5px",
    "minWidth": "120px",
    "padding": "4px"
}, {
    "minWidth": "230px",
    "backgroundColor": "var(--color-box-bg)",
    "color": "var(--color-desc-text)",
    "padding": "8px",
    "marginTop": "20px",
    "borderRadius": "8px"
}, {
    "display": "block",
    "paddingLeft": "12px",
    "paddingRight": "12px",
    "paddingTop": "9px",
    "paddingBottom": "9px",
    "fontSize": "14px",
    "lineHeight": "22px",
    "cursor": "pointer",
    "borderRadius": "3px"
}, {
    "color": "var(--color-text-primary)",
    "backgroundColor": "var(--color-select-bg)",
    "fontWeight": "600"
});
export default function CToolTip(props) {
    var _ref = props || {}, options = _ref.options, target = _ref.target, arg = _objectWithoutProperties(_ref, [
        "options",
        "target"
    ]);
    return(/*#__PURE__*/ _jsx(Ttip, _objectSpread({
        placement: "bottom",
        overlayClassName: "popover",
        hideArrow: true,
        overlay: /*#__PURE__*/ _jsx(TooltipStyled, {
            className: "header-tooltip",
            children: options
        })
    }, arg, {
        children: target
    })));
};
